function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import styled from "styled-components";
import { space, color } from "styled-system";
var Svg = styled("svg")({
  flex: "none"
}, space, color);
var SvgQiwi = React.forwardRef(function (props, ref) {
  return React.createElement(Svg, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    height: props.size,
    width: props.size,
    ref: ref
  }), React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M16.942 14.584c.039.3-.047.417-.142.417-.095 0-.229-.117-.371-.349-.143-.232-.2-.495-.124-.63.047-.088.152-.127.276-.078.247.097.343.475.361.64zm-1.332.66c.295.252.38.542.228.756a.497.497 0 01-.39.174.672.672 0 01-.448-.165c-.266-.233-.343-.62-.172-.834a.367.367 0 01.306-.135c.152 0 .323.067.476.203zM5.25 11.17C5.25 7.486 8.182 4.5 11.8 4.5c3.62 0 6.552 2.987 6.552 6.67a6.805 6.805 0 01-.924 3.424c-.019.029-.067.019-.076-.02-.228-1.639-1.209-2.54-2.637-2.812-.124-.02-.143-.097.019-.116.438-.039 1.056-.03 1.38.03.02-.171.03-.343.029-.515 0-2.434-1.943-4.412-4.333-4.412s-4.332 1.978-4.332 4.412 1.943 4.412 4.332 4.412h.2a6.061 6.061 0 01-.086-1.193c.01-.271.068-.31.182-.097.6 1.058 1.456 2.008 3.133 2.385 1.37.311 2.741.67 4.217 2.58.133.165-.066.339-.218.203-1.505-1.357-2.876-1.803-4.123-1.803-1.4.01-2.352.195-3.315.195-3.618 0-6.55-2.989-6.55-6.673z",
    fill: "white"
  }));
});
SvgQiwi.displayName = "SvgQiwi";
SvgQiwi.defaultProps = {
  size: 24,
  color: "#FF8C00"
};
export default SvgQiwi;